import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { CampaignType } from "@front/m19-api-client";
import { TranslocoDirective } from "@jsverse/transloco";
import { IIconComponent, ITooltipDirective, Placement } from "@front/m19-ui";

@Component({
  selector: "app-disable-auto-warning",
  templateUrl: "./disable-auto-warning.component.html",
  styleUrls: ["./disable-auto-warning.component.scss"],
  imports: [ITooltipDirective, TranslocoDirective, IIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DisableAutoWarningComponent {
  @Input({ required: true })
  campaignType!: CampaignType;
  @Input()
  tooltipPosition: Placement = "top";
}
